<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>
      @if (topBarConfig().titleKey) {
        {{ topBarConfig().titleKey | translate }}
      } @else {
        {{ topBarConfig().title }}
      }
    </ion-title>
    @if (topBarConfig().showMenuButton) {
      <ion-buttons slot="end">
        <ion-menu-button aria-label="Menu">
          <ion-icon
            aria-hidden="true"
            src="../assets/material-symbols/account_circle_24dp.svg"
          ></ion-icon>
        </ion-menu-button>
        @if (topBarConfig().showNoticesButton && isDesktopView() && notices?.hasNotices()) {
          <ion-button
            color="warning"
            fill="solid"
            shape="round"
            (click)="goToNotices()"
          >
            <ion-icon
              slot="icon-only"
              aria-label="view notices"
              src="../assets/material-symbols/notification_important_24dp.svg"
            ></ion-icon>
          </ion-button>
        }
      </ion-buttons>
    }
    @if (topBarConfig().showBackButton && !isDesktopView()) {
      <ion-buttons slot="start">
        <ion-back-button [defaultHref]="topBarConfig().backHref ?? DEFAULT_BACK_HREF"></ion-back-button>
      </ion-buttons>
    }
    @if (topBarConfig().showCancelButton) {
      <ion-buttons slot="start">
        <ion-button (click)="topBarConfig().cancelAction?.()">
          {{ topBarConfig().cancelLabel ?? DEFAULT_CANCEL_LABEL | translate }}
        </ion-button>
      </ion-buttons>
    }
    @if (topBarConfig().topBarButtons?.length) {
      <ion-buttons slot="end">
        @for (btn of topBarConfig().topBarButtons; track $index) {
          @if (!btn.hideInMobile || isDesktopView()) {
            <ion-button
              [fill]="btn.isPrimaryAction ? 'solid' : undefined"
              [class.okc-toolbar-btn]="btn.isPrimaryAction"
              [attr.aria-label]="btn.label ?? null"
              [disabled]="!!btn.disabled"
              (click)="btn.action()"
            >
              <ion-icon
                aria-hidden="true"
                [src]="btn.icon"
                [slot]="showActionLabel(btn) ? 'start' : 'icon-only'"
              ></ion-icon>
              @if (showActionLabel(btn)) {
                {{ btn.label }}
              }
            </ion-button>
          }
        }
      </ion-buttons>
    }
  </ion-toolbar>
  @if (topBarConfig().showNoticesButton && !isDesktopView() && notices?.hasNotices()) {
    <lib-top-bar-notice
      [labelKey]="notices?.labelKey ?? DEFAULT_NOTICES_LABEL"
      (noticeClick)="goToNotices()"
    ></lib-top-bar-notice>
  }
</ion-header>
